import React, {useEffect, useState} from 'react';
import {Icon, Typography} from "@bonprix/design-system";
import MessageBroker from "@bonprix/pattern-library/components/message-broker.js";
import {SideSectionAction} from "@product/sections/SideSectionAction.tsx";
import {useQuery} from "@tanstack/react-query";
import SizeAdviceApi from "@product/apis/size-advice-api.js";
import ProductMessages from "@product/components/message-list.js";
import TrinityHelper from "@product/helper/trinity/trinity.js";

export default function SizeAdvice({product, texts, onLoaded}) {
    const {currentItem} = product;

    const [item, setItem] = useState(currentItem);

    const {data: sizeAdvice} = useQuery({
        queryKey: ['sizeAdvice', item],
        queryFn: () => SizeAdviceApi.loadSizeAdviceWithoutErrorCatch(item.itemNumber),
        refetchOnWindowFocus: false,
        enabled: !!item,
        retry: false
    });

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.CHANGED, ({item}) => {
            if (item) {
                setItem(item);
            }
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    useEffect(() => {
        if (sizeAdvice) {
            onLoaded?.(sizeAdvice);
        }
    }, [sizeAdvice]);

    if (!sizeAdvice) {
        return null;
    }

    const sizeAdviceItemOption = item.itemOptions.find(itemOption => itemOption.id === sizeAdvice.itemOptionId);
    if (!sizeAdviceItemOption) {
        return null;
    }

    const content = texts.pdp__size_advice_explanation_text;

    const onClick = () => {
        TrinityHelper.sendClickSizeAdvice(true);
        MessageBroker.publish(SideSectionAction.OPEN, {
            nodes: {
                title: texts.pdp__size_advice_explanation_headline,
                content: (
                    <Typography variant="body1" component="div" color="on-bg-mid">
                        <div className="size-advice__explanation" dangerouslySetInnerHTML={{__html: content}}/>
                    </Typography>
                )
            },
            onCloseCallback: () => {
                TrinityHelper.sendClickSizeAdvice(false);
            },
            afterOpenedCallback: () => {
                TrinityHelper.sendLayerViewSizeAdvice();
            }
        });
    };

    return (
        <div className="product__size-advice">
            <div className="size-advice bg-clr-bg-info" onClick={onClick}>
                <div className="size-advice__info">
                    <Icon className="fill-clr-fg-info" variant="light-bulb"/>
                    <div className="size-advice__text">
                        <Typography variant="body1" color="on-bg-mid">{texts.pdp__size_advice_text}&nbsp;</Typography>
                        <Typography variant="body1" color="on-bg-mid" bold>{texts.ada_gr} {sizeAdviceItemOption.name}</Typography>
                    </div>
                </div>
                <Icon className="" variant="arrow-right"/>
            </div>
        </div>
    );
}